.tooltip-wrapper {
  --tooltip-arrow-height: 8px;
  position: relative;
  z-index: 1;
}

.tooltip-wrapper-enabled {
  cursor: pointer;

  &:hover .tooltip-bubble {
    display: initial;
  }
}

.tooltip-bubble {
  display: none;
  position: absolute;
  width: max-content;
  z-index: 1;
}

.tooltip-style-dark {
  & .tooltip-bubble {
    background: var(--ds-grey-dark);
    color: var(--ds-white);
  }

  &:not(.no-arrow) .tooltip-bubble-above:after {
    border-top-color: var(--ds-grey-dark);
  }

  &:not(.no-arrow) .tooltip-bubble-right:after {
    border-right-color: var(--ds-grey-dark);
  }
}

.tooltip-style-light {
  & .tooltip-bubble {
    background: var(--ds-pearl-grey);
    color: var(--ds-black);
  }

  &:not(.no-arrow) .tooltip-bubble-above:after {
    border-top-color: var(--ds-pearl-grey);
  }

  &:not(.no-arrow) .tooltip-bubble-right:after {
    border-right-color: var(--ds-pearl-grey);
  }
}

/* https://leaverou.github.io/bubbly/ */
.tooltip-bubble-above {
  left: 50%;
  transform: translateX(-50%);
}

.tooltip-bubble-right {
  top: 50%;
  transform: translateY(-50%);
}

.tooltip-bubble-above-arrow:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 0;
  border: 9px solid transparent;
  border-bottom: 0;
  /*
   NB: don't delete the 'px' in '0px'! It doesn't work in calc()!
   https://stackoverflow.com/a/55391061/2544629
   */
  margin-bottom: calc(0px - var(--tooltip-arrow-height));
  margin-left: calc(0px - var(--tooltip-arrow-height));
}

.tooltip-bubble-right-arrow:after {
  content: '';
  position: absolute;
  bottom: 0;
  top: 50%;
  width: 0;
  height: 0;
  border: 9px solid transparent;
  border-left: 0;
  margin-top: calc(0px - var(--tooltip-arrow-height));
  margin-left: calc(0px - var(--tooltip-arrow-height));
}
